import {
  Dropdown,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MenuOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.scss";
import PDFModal from "./component/PDFModal"
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [periodList, setPeriodList] = useState([]);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const initTableHead = {
    vendorName: null,
    requestNumber: null,
    payAmount: null,
    requestDate: null,
    requestStatus: null,
    jobs: null,
    supervisor: null,
    rejectedReason: null,
    needMaterial: null,
    materialAmount: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    //   width: 50,
    // },
    {
      title: "Vendor",
      dataIndex: "vendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Request Number",
      dataIndex: "requestNumber",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "requestNumber"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "payAmount"),
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'requestDate', 'DatePicker'),
    },
    {
      title: "Request Status",
      dataIndex: "requestStatus",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "requestStatus"),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobType"),
      width: 200,
      render: (text) => {
        return (
          <>
            {(text || [])?.map(item => (
               <div>
                { item }
              </div>
            ))}
          </>
        )
      }
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor')
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    {
      title: "Need Material",
      dataIndex: "needMaterial",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "needMaterial"),
    },
    {
      title: "Material $",
      dataIndex: "materialAmount",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "materialAmount"),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      monthlyWorkerPayId: new URLSearchParams(location.search).get("monthlyWorkerPayId"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.showMonthlyWorkerSubDetail, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //复选框
  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const PDFModalRef = useRef();
  
  const getDictionaryFn = async(value) => {
    const response = await http.get(api.getPeriodList);
    setPeriodList((response.data || [])?.map(item => ({
      label: item,
      value: item,
    })))
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(periodList?.length){
      setColumns(initColumns);
    }
  }, [periodList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      monthlyWorkerPayId: new URLSearchParams(location.search).get("monthlyWorkerPayId"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportMonthlyWorkerDetailCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `Maintenance_monthly_worker`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          monthlyWorkerPayId={new URLSearchParams(location.search).get("monthlyWorkerPayId")}
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      <PDFModal ref={PDFModalRef} record={currentRecord} />

    </div>
  );
});
export default MainTable;
